import classnames from "classnames";
import { Card, CardBody, CardText } from "reactstrap";
import { Download, Play } from "react-feather";
import { store } from "@store/StoreConfig";
import { Badge } from "reactstrap";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { BsMusicNoteList } from "react-icons/bs";
import { useSelector } from "react-redux";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { MdOutlineCategory } from "react-icons/md";
import { CiTimer } from "react-icons/ci";

const PlaylistCards = (props) => {
  const { datas, activeView, bycategory } = props;
  const shareUrl = window.location.origin;
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  let data = {
    currentsong: null,
    download: null,
    namesong: "",
    songimg: "",
    is_web_rtc: false,
    item_data: null,
  };
  const dataTorender = () => {
    return bycategory ? datas?.dataBycategory : datas?.data;
  };
  const renderdata = () => {
    if (dataTorender()?.length) {
      return dataTorender()?.map((item, i) => {
        return (
          <Card
            className="ecommerce-card pointer_cursor"
            key={item.id}
            style={{ gridTemplateColumns: "2fr 2fr 1fr" }}
          >
            <div
              className="text-center"
              style={{ width: "100%", height: "170px" }}
            >
              <img
                width="100%"
                height="100%"
                className="card-img-top"
                src={item.picture}
                alt="emission_picture"
              />
              <div
                className="playlist-play-button"
                style={{
                  position: "absolute",
                  top: "25%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  msTransform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  color: "#8134af",
                  fontSize: "16px",
                  padding: "12px 24px",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "5px",
                  textAlign: "center",
                }}
              >
                {PlayerFrontOfficeReducer?.currentSong === item.file_path ? (
                  <BsMusicNoteList size={20} />
                ) : (
                  <Fragment>
                    <Play
                      onClick={() =>
                        store.dispatch(
                          addMusic(
                            (data = {
                              currentsong: item.file_path,
                              namesong: `${item.name}`,
                              item_data: item,
                              is_web_rtc: false,
                              has_video:
                                item.media?.filter(
                                  (el) => el.media_type_id === 3
                                )?.length > 0
                                  ? true
                                  : false,
                              songimg: item.picture,
                            })
                          )
                        )
                      }
                      className="mr-50"
                      id="Play"
                      style={{ display: "inline !important" }}
                      size={20}
                    />
                  </Fragment>
                )}
              </div>
            </div>
            <CardBody tag="div">
              <div style={{ textAlign: "center" }}>
                <div className="item-cost">
                  <h6 className="item-price">
                    <div
                      className="text-center mx-auto cursor-pointer me-50 py-50"
                      style={{ flexDirection: "row" }}
                    >
                      <Link
                        to={`/playlist/${item.id}`}
                        style={{ marginRight: "5px" }}
                      >
                        <FaEye
                          style={{ display: "inline !important" }}
                          size={20}
                          id="Show"
                        />
                      </Link>
                      <a
                        href={item.file_path}
                        style={{ textDecoration: "black" }}
                        download
                      >
                        <Download
                          size={20}
                          className="mr-50 pointer_cursor"
                          id="Download"
                        />
                      </a>
                    </div>
                  </h6>
                </div>
              </div>

              <CardText tag="div" className="item-name">
                <h4 id="Name">
                  <div className="mail-body">
                    <div className="mail-message">
                      <h3 className="text-truncate mb-0">
                        <Link
                          to={`/playlist/${item.id}`}
                          style={{ marginRight: "5px" }}
                        >
                          {item.name}
                        </Link>
                      </h3>
                    </div>
                  </div>
                  <span
                    style={{
                      display: "flex",
                      alignContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      marginTop: "15px",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignContent: "center",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "flex-start",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          flexWrap: "nowrap",
                        }}
                      >
                        <p style={{ fontSize: "15px" }}>
                          <CiTimer style={{ fontSize: "15px" }} /> duration
                        </p>
                      </span>

                      <p style={{ fontSize: "15px", marginLeft: "5px" }}>
                        {item.playtime_string}
                      </p>
                    </span>
                  </span>
                  <span
                    style={{
                      display: "flex",
                      alignContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignContent: "center",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        flexWrap: "nowrap",
                      }}
                    >
                      <p style={{ fontSize: "15px" }}>
                        <MdOutlineCategory style={{ fontSize: "15px" }} />{" "}
                        categories
                      </p>
                    </span>

                    <span
                      style={{
                        marginLeft: "5px",
                        display: "flex",
                        alignContent: "center",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      {item.categories?.map((ele, i) => (
                        <Link key={i} to={`/playlists/category/${ele.id}`}>
                          <Badge
                            style={{ margin: "2px" }}
                            color="light-warning"
                          >
                            {ele.name}
                          </Badge>
                        </Link>
                      ))}
                    </span>
                  </span>
                </h4>
              </CardText>

              <div className="item-cost">
                <h6 className="item-price">
                  <CardText tag="div">
                    <ul
                      className="blog-icon-podcast"
                      style={{ textAlign: "center" }}
                    >
                      <li>
                        <FacebookShareButton
                          url={`${shareUrl}/playlist/${item.id}`}
                        >
                          <FacebookIcon size={30} round={true} />
                        </FacebookShareButton>
                      </li>

                      <li>
                        <TwitterShareButton
                          url={`${shareUrl}/playlist/${item.id}`}
                        >
                          <TwitterIcon size={30} round={true} />
                        </TwitterShareButton>
                      </li>
                      <li>
                        <WhatsappShareButton
                          url={`${shareUrl}/playlist/${item.id}`}
                        >
                          <WhatsappIcon size={30} round={true} />
                        </WhatsappShareButton>
                      </li>
                      <li>
                        <FacebookMessengerShareButton
                          url={`${shareUrl}/playlist/${item.id}`}
                        >
                          <FacebookMessengerIcon size={30} round={true} />
                        </FacebookMessengerShareButton>
                      </li>
                    </ul>
                  </CardText>
                </h6>
              </div>
            </CardBody>
            <div className="item-options text-center">
              <h4 className="item-price">
                <div
                  className="text-center mx-auto cursor-pointer me-50 py-50"
                  style={{ flexDirection: "row" }}
                >
                  <Link
                    to={`/playlist/${item.id}`}
                    style={{ marginRight: "5px" }}
                  >
                    <FaEye
                      style={{ display: "inline !important" }}
                      size={20}
                      id="Show"
                    />
                  </Link>
                  <a
                    href={item.file_path}
                    style={{ textDecoration: "black" }}
                    download
                  >
                    <Download
                      size={20}
                      className="mr-50 pointer_cursor"
                      id="Download"
                    />
                  </a>
                </div>
                <div>
                  <ul
                    className="blog-icon-podcast"
                    style={{ textAlign: "center" }}
                  >
                    <li>
                      <FacebookShareButton
                        url={`${shareUrl}/playlist/${item.id}`}
                      >
                        <FacebookIcon size={30} round={true} />
                      </FacebookShareButton>
                    </li>

                    <li>
                      <TwitterShareButton
                        url={`${shareUrl}/playlist/${item.id}`}
                      >
                        <TwitterIcon size={30} round={true} />
                      </TwitterShareButton>
                    </li>
                    <li>
                      <WhatsappShareButton
                        url={`${shareUrl}/playlist/${item.id}`}
                      >
                        <WhatsappIcon size={30} round={true} />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <FacebookMessengerShareButton
                        url={`${shareUrl}/playlist/${item.id}`}
                      >
                        <FacebookMessengerIcon size={30} round={true} />
                      </FacebookMessengerShareButton>
                    </li>
                  </ul>
                </div>
              </h4>
            </div>
          </Card>
        );
      });
    }
  };

  return (
    <div
      className={classnames({
        "grid-view": activeView === "grid",
        "list-view": activeView === "list",
      })}
    >
      {renderdata()}
    </div>
  );
};

export default PlaylistCards;
